import PromptUserConsent from './PromptUserConsent.jsx';

export default PromptUserConsent;
